import type { ReactNode } from 'react';
import { bloxValues } from 'themes/constants';

const Heading = ({
  children,
  styles,
}: {
  children?: ReactNode;
  styles?: Record<string, unknown>;
}) => {
  const headingStyle = {
    margin: '8px 0px',
    fontSize: bloxValues.xlFontSizeRem,
  };

  return (
    <h3
      className="blox-heading"
      style={{ ...headingStyle, ...styles }}
    >
      {children}
    </h3>
  );
};

export default Heading;
